export default (data, customEntities) => {
    return data.sort((a, b) => {
        const aMatch = customEntities.find(entity => entity.name.toLowerCase() === a.name.toLowerCase());
        const bMatch = customEntities.find(entity => entity.name.toLowerCase() === b.name.toLowerCase());
        if (aMatch && bMatch) {
            return 0;
        }
        if (aMatch) {
            return -1;
        }
        if (bMatch) {
            return 1;
        }
        return 0;
    });
}